export default {
  meta: {
    title: '订单详情',
    parentPath: ['/locxx/order'],
    breadcrumbs: {
      path: ['/locxx/order'],
      name: ['订单管理'],
    },
  }
};
